import { render, staticRenderFns } from "./SideContainer.vue?vue&type=template&id=74d87e18&scoped=true&"
import script from "./SideContainer.vue?vue&type=script&lang=js&"
export * from "./SideContainer.vue?vue&type=script&lang=js&"
import style0 from "./SideContainer.vue?vue&type=style&index=0&id=74d87e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d87e18",
  null
  
)

export default component.exports